import styled from "styled-components";

export const PriceDetails = styled.div.attrs(() => ({
    className: "priceDetails",
}))``;

export const BasePrice = styled.span.attrs(() => ({
    className: "base-price",
}))``;

export const Price = styled.span.attrs(() => ({
    className: "price",
}))``;

export const CrossedPrice = styled.span.attrs(() => ({
    className: "crossedPrice",
}))``;

export const RealPrice = styled.span.attrs(() => ({
    className: "real-price",
}))``;

export const MonthlyPriceWrapper = styled.div`
    display: flex;
`;
